<template>
  <div class="not-found f-center">
    <h3 class="info">加载中...</h3>
  </div>
</template>

<script>
  export default {
	name: "WxApp",

	data() {
	  return {};
	},

	watch: {},

	created() {
	  //跳转H5页面
	  let that = this;
	  setTimeout(function () {
		that.$router.push('/verified-step2?type=liveResult');
	  }, 1000);
	  //跳转微信小程序
	  wx.miniProgram.getEnv(function (res) {
		if (res.miniprogram) {
		  wx.miniProgram.redirectTo({url: "/packageA/pages/liveness/liveness?bType=liveResult"});
		}
	  });
	},

	methods: {}
  };
</script>

<style lang="less" scoped>
  .not-found {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 375px;
  }

  .info {
    font-size: 16px;
    text-align: center;
    margin: 30px;
  }
</style>
